export const DEFAULT_LAT = 52.1344;
export const DEFAULT_LON = 5.1917;
export const DEFAULT_ZOOM = 6.8;
